import React, { useRef } from "react";

const NewRisk = ({ onSubmit }) => {
	const nameRef = useRef();
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				const name = nameRef.current.value;
				if (name) {
					onSubmit(name);
					nameRef.current.value = "";
					nameRef.current.focus();
				}
			}}
		>
			<div className="form-row">
				<div className="col-10">
					<input
						type="text"
						id="new-risk"
						name="new-risk"
						ref={nameRef}
						required
						className="form-control input-height"
						placeholder="enter risk here"
					/>
				</div>

				<div className="col">
					<button
						type="submit"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-5 btn-circle btn-success"
					>
						Add Risk
						<i className="material-icons">arrow_right_alt</i>
					</button>
				</div>
			</div>
		</form>
	);
};
export default NewRisk;
